<template>
  <div class="page-tarifs">
    <landing-header />
    <main>

      <!-- ===== HERO ===== -->
      <section class="hero-tarifs">
        <div class="max-w-4xl mx-auto px-4 text-center">
          <span class="hero-badge">Tarifs transparents · Sans engagement</span>
          <h1 class="hero-title">
            Un outil complet.<br/>
            <span class="gradient-text">Une solution pour tous.</span>
          </h1>
          <p class="hero-sub">
            Pas de fonctionnalité cachée derrière un module payant. Choisissez votre offre selon votre structure — et évoluez quand vous grandissez.
          </p>
          <!-- <div class="hero-toggle">
            <span :class="!annuel ? 'toggle-active' : ''" @click="annuel = false">Mensuel</span>
            <div class="toggle-switch" @click="annuel = !annuel" :class="annuel ? 'toggled' : ''">
              <div class="toggle-thumb"></div>
            </div>
            <span :class="annuel ? 'toggle-active' : ''" @click="annuel = true">
              Annuel
              <span class="toggle-save">−20%</span>
            </span>
          </div> -->
        </div>
      </section>

      <!-- ===== CARDS ===== -->
      <section class="cards-section">
        <div class="max-w-6xl mx-auto px-4">
          <div class="cards-grid">

            <!-- INDÉPENDANT -->
            <div class="tier-card">
              <div class="tier-head">
                <div class="tier-icon indep-icon"><i class="fa-solid fa-helmet-safety"></i></div>
                <div class="tier-name">Indépendant</div>
                <div class="tier-tagline">L'artisan solo qui veut être organisé et conforme</div>
                <div class="tier-price">
                  <span class="tp-val">{{ annuel ? '24' : '30' }} €</span>
                  <span class="tp-unit">/mois HT</span>
                </div>
                <div class="tier-old" v-if="!annuel">Prix habituel · tarif mensuel</div>
                <div class="tier-old" v-else>au lieu de 30 € · facturé annuellement</div>
                <a href="/register"><button class="btn-indep">Démarrer l'essai gratuit</button></a>
                <div class="trial-note">14 jours gratuits · Sans carte bancaire</div>
              </div>
              <div class="tier-body">
                <div class="tier-limit-banner">
                  <i class="fa-solid fa-user"></i> 1 utilisateur inclus
                </div>
                <div class="tier-section-title">Ce qui est inclus</div>
                <div class="feat-list">
                  <div class="fl-item" v-for="f in indepFeatures" :key="f.label">
                    <i class="fa-solid fa-check fl-check"></i>
                    <div>
                      <strong>{{ f.label }}</strong>
                      <span v-if="f.note" class="fl-note">{{ f.note }}</span>
                    </div>
                  </div>
                </div>
                <div class="tier-section-title mt-6">Non inclus</div>
                <div class="feat-list">
                  <div class="fl-item fl-missing" v-for="f in indepMissing" :key="f">
                    <i class="fa-solid fa-xmark fl-x"></i>
                    <span>{{ f }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- ENTREPRISE — FEATURED -->
            <div class="tier-card tier-featured">
              <div class="featured-ribbon">Recommandé</div>
              <div class="tier-head featured-head">
                <div class="tier-icon entreprise-icon"><i class="fa-solid fa-building"></i></div>
                <div class="tier-name featured-name">Entreprise</div>
                <div class="tier-tagline featured-tagline">Pour les équipes qui veulent facturer, piloter et développer</div>
                <div class="tier-price">
                  <span class="tp-val">{{ annuel ? '44' : '55' }} €</span>
                  <span class="tp-unit">/tech/mois HT</span>
                </div>
                <div class="tier-old featured-old" v-if="!annuel">Prix habituel · tarif mensuel</div>
                <div class="tier-old featured-old" v-else>au lieu de 55 € · facturé annuellement</div>
                <a href="/contact"><button class="btn-entreprise">Demander une démonstration</button></a>
                <div class="trial-note featured-trial">14 jours gratuits · Onboarding inclus</div>
              </div>
              <div class="tier-body featured-body">
                <div class="featured-value-banner">
                  <i class="fa-solid fa-fire-burner"></i>
                  <span>Tout l'Indépendant, plus la facturation, le portail client, la prise de RDV et le pilotage avancé</span>
                </div>
                <div class="tier-section-title">Tout l'Indépendant +</div>
                <div class="feat-list">
                  <div class="fl-item fl-extra" v-for="f in entrepriseExtra" :key="f.label">
                    <i class="fa-solid fa-plus fl-plus"></i>
                    <div>
                      <strong>{{ f.label }}</strong>
                      <span v-if="f.note" class="fl-note">{{ f.note }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- SUR MESURE -->
            <div class="tier-card tier-custom">
              <div class="tier-head">
                <div class="tier-icon custom-icon"><i class="fa-solid fa-sliders"></i></div>
                <div class="tier-name">Sur mesure</div>
                <div class="tier-tagline">10 techniciens et plus · Groupes · Multi-agences</div>
                <div class="tier-price">
                  <span class="tp-val custom-val">Sur devis</span>
                </div>
                <div class="tier-old">Tarif dégressif selon le volume</div>
                <a href="/contact"><button class="btn-custom">Nous contacter</button></a>
                <div class="trial-note">Réponse sous 24h</div>
              </div>
              <div class="tier-body">
                <div class="tier-section-title">Ce que ça inclut</div>
                <div class="feat-list">
                  <div class="fl-item" v-for="f in customFeatures" :key="f">
                    <i class="fa-solid fa-check fl-check"></i>
                    <span>{{ f }}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <!-- ===== TABLEAU COMPARATIF ===== -->
      <section class="compare-section">
        <div class="max-w-5xl mx-auto px-4">
          <div class="text-center mb-12">
            <h2 class="text-3xl font-black text-gray-900 mb-3">Ce qui change vraiment entre les offres</h2>
            <p class="text-gray-500">Comparez fonctionnalité par fonctionnalité pour choisir en toute clarté.</p>
          </div>
          <div class="compare-table">
            <div class="ct-head">
              <div class="ct-feat-col"></div>
              <div class="ct-plan-col">
                <div class="ct-plan-name">Indépendant</div>
                <div class="ct-plan-price">30 €<span>/mois</span></div>
              </div>
              <div class="ct-plan-col ct-featured-col">
                <div class="ct-plan-badge">Recommandé</div>
                <div class="ct-plan-name featured-plan-name">Entreprise</div>
                <div class="ct-plan-price featured-plan-price">55 €<span>/tech/mois</span></div>
              </div>
              <div class="ct-plan-col">
                <div class="ct-plan-name">Sur mesure</div>
                <div class="ct-plan-price">Sur devis</div>
              </div>
            </div>

            <div class="ct-group" v-for="group in compareGroups" :key="group.label">
              <div class="ct-group-label">{{ group.label }}</div>
              <div class="ct-row" v-for="row in group.rows" :key="row.feat">
                <div class="ct-feat">
                  {{ row.feat }}
                  <span v-if="row.tip" class="ct-tip" :title="row.tip">?</span>
                </div>
                <div class="ct-cell">
                  <template v-if="row.indep === true"><i class="fa-solid fa-check ct-yes"></i></template>
                  <template v-else-if="row.indep === false"><i class="fa-solid fa-xmark ct-no"></i></template>
                  <template v-else><span class="ct-partial">{{ row.indep }}</span></template>
                </div>
                <div class="ct-cell ct-featured-cell">
                  <template v-if="row.entreprise === true"><i class="fa-solid fa-check ct-yes"></i></template>
                  <template v-else-if="row.entreprise === false"><i class="fa-solid fa-xmark ct-no"></i></template>
                  <template v-else><span class="ct-partial">{{ row.entreprise }}</span></template>
                </div>
                <div class="ct-cell">
                  <template v-if="row.custom === true"><i class="fa-solid fa-check ct-yes"></i></template>
                  <template v-else-if="row.custom === false"><i class="fa-solid fa-xmark ct-no"></i></template>
                  <template v-else><span class="ct-partial">{{ row.custom }}</span></template>
                </div>
              </div>
            </div>

            <div class="ct-foot">
              <div class="ct-feat-col"></div>
              <div class="ct-cta-cell">
                <a href="/register"><button class="cta-table-btn cta-outline">Essai gratuit</button></a>
              </div>
              <div class="ct-cta-cell">
                <a href="/contact"><button class="cta-table-btn cta-orange">Demander une démo</button></a>
              </div>
              <div class="ct-cta-cell">
                <a href="/contact"><button class="cta-table-btn cta-outline">Nous contacter</button></a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- ===== ROI RAPIDE ===== -->
      <section class="roi-section">
        <div class="max-w-5xl mx-auto px-4 text-center">
          <h2 class="text-3xl font-black text-gray-900 mb-4">Rentabilisé dès le premier mois</h2>
          <p class="text-gray-500 mb-12">Un devis non relancé, une heure de paperasse évitée, une facture payée plus vite — Termoflow se paye lui-même en quelques jours.</p>
          <div class="roi-grid">
            <div class="roi-item">
              <div class="roi-val">+1 h</div>
              <div class="roi-lab">récupérée par jour sur l'administratif</div>
            </div>
            <div class="roi-item">
              <div class="roi-val">−22 j</div>
              <div class="roi-lab">de délai de paiement moyen</div>
            </div>
            <div class="roi-item">
              <div class="roi-val">0</div>
              <div class="roi-lab">risque de contrôle fiscal</div>
            </div>
            <div class="roi-item">
              <div class="roi-val">+35%</div>
              <div class="roi-lab">d'avis Google en 3 mois</div>
            </div>
          </div>
          <a href="/roi/calculator" class="roi-cta-link">
            Calculer mon ROI précis <i class="fa-solid fa-arrow-right"></i>
          </a>
        </div>
      </section>

      <!-- ===== FAQ ===== -->
      <section class="faq-section">
        <div class="max-w-3xl mx-auto px-4">
          <h2 class="text-2xl font-black text-gray-900 text-center mb-8">Questions fréquentes sur les tarifs</h2>
          <div class="faq-list">
            <div class="faq-item" v-for="faq in faqs" :key="faq.q" @click="faq.open = !faq.open">
              <div class="faq-q">
                {{ faq.q }}
                <i :class="faq.open ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
              </div>
              <div class="faq-a" v-if="faq.open">{{ faq.a }}</div>
            </div>
          </div>
        </div>
      </section>

      <!-- ===== CTA FINAL ===== -->
      <section class="cta-final">
        <div class="max-w-3xl mx-auto px-4 text-center">
          <h2 class="text-4xl font-black text-white mb-4">Pas encore sûr de votre choix ?</h2>
          <p class="text-slate-400 text-xl mb-10">On vous montre Termoflow en action, sur vos cas concrets, sans script générique.</p>
          <div class="flex flex-wrap gap-4 justify-center">
            <a href="/contact"><button class="btn-cta-white">Parler à un conseiller</button></a>
            <a href="/register"><button class="btn-cta-orange">Démarrer l'essai gratuit</button></a>
          </div>
          <p class="mt-6 text-slate-500 text-sm">14 jours gratuits · Sans carte bancaire · Sans engagement</p>
        </div>
      </section>

    </main>
    <landing-footer />
  </div>
</template>

<script>
import LandingHeader from './LandingHeader.vue'
import LandingFooter from './LandingFooter.vue'
export default {
  name: 'LandingTarifs',
  components: { LandingHeader, LandingFooter },
  data() {
    return {
      annuel: false,
      indepFeatures: [
        { label: 'Suivi des interventions', note: 'Statuts, rapports, photos terrain' },
        { label: 'Application mobile', note: 'iOS & Android, mode offline' },
        { label: 'Planning journalier', note: 'Vue jour & semaine, 1 technicien' },
        { label: 'Gestion des chantiers', note: 'Clients, adresse, historique' },
        { label: 'CERFA & fluides frigorigènes', note: 'Génération automatique' },
        { label: 'Bouteilles & traçabilité', note: 'Suivi des stocks de fluides' },
        { label: 'Détecteurs de gaz', note: 'Alertes d\'étalonnage' },
        { label: 'Gestion du stock', note: 'Camion + dépôt' },
        { label: 'Contrats d\'entretien', note: 'Suivi et relances auto' },
        { label: 'Statistiques basiques', note: 'Activité du mois, interventions' },
        { label: 'Export Excel', note: 'Stock & fluides' },
      ],
      indepMissing: [
        'Facturation (devis, factures, relances)',
        'Prise de RDV en ligne',
        'Portail client',
        'Planning multi-techniciens',
        'Communication automatisée (SMS, avis Google)',
        'Statistiques avancées & rentabilité',
        'Paramétrage métier complet',
      ],
      entrepriseExtra: [
        { label: 'Facturation complète', note: 'Devis, factures, acomptes, relances — certifié anti-fraude TVA & e-invoicing 2026' },
        { label: 'Prise de RDV en ligne', note: 'Calendrier intégrable sur votre site, personnalisable à 100%' },
        { label: 'Portail client', note: 'Espace sécurisé : CERFA, documents, historique, prise de RDV' },
        { label: 'Planning multi-techniciens', note: 'Par demi-journée, couleur par technicien, détection de conflits' },
        { label: 'Communication automatisée', note: 'SMS rappel RDV, email post-intervention, avis Google auto' },
        { label: 'Statistiques avancées', note: 'Marge par technicien, rentabilité par chantier, taux de transformation devis' },
        { label: 'Paramétrage métier complet', note: 'Types d\'appareils, interventions, travaux, points de contrôle, tarifs' },
        { label: 'Utilisateurs illimités', note: 'Techniciens + secrétaires + gérants' },
        { label: 'Support prioritaire + onboarding', note: 'Session de configuration en visio + suivi à 30 jours' },
      ],
      customFeatures: [
        'Tout l\'offre Entreprise sans limite',
        'Tarif dégressif dès 10 techniciens',
        'Multi-agences & multi-dépôts',
        'Intégrations personnalisées',
        'Onboarding dédié & formation équipe',
        'Account manager attitré',
        'SLA de disponibilité garanti',
        'Contrat adapté à vos besoins',
      ],
      compareGroups: [
        {
          label: 'Utilisateurs & accès',
          rows: [
            { feat: 'Nombre d\'utilisateurs', indep: '1 inclus', entreprise: 'Illimité', custom: 'Illimité' },
            { feat: 'Application mobile (iOS & Android)', indep: true, entreprise: true, custom: true },
            { feat: 'Mode offline complet', indep: true, entreprise: true, custom: true },
          ]
        },
        {
          label: 'Terrain & chantiers',
          rows: [
            { feat: 'Suivi des interventions', indep: true, entreprise: true, custom: true },
            { feat: 'Suivi des chantiers (carte, contacts)', indep: true, entreprise: true, custom: true },
            { feat: 'Planning', indep: '1 technicien', entreprise: 'Multi-techniciens', custom: 'Multi-techniciens' },
            { feat: 'Prise de RDV en ligne (widget site)', indep: false, entreprise: true, custom: true },
            { feat: 'Gestion du stock camion & dépôt', indep: true, entreprise: true, custom: true },
            { feat: 'Multi-dépôts', indep: false, entreprise: true, custom: true },
          ]
        },
        {
          label: 'Facturation',
          rows: [
            { feat: 'Facturation (devis, factures, acomptes)', indep: false, entreprise: true, custom: true },
            { feat: 'Relances automatiques', indep: false, entreprise: true, custom: true },
            { feat: 'Certification anti-fraude TVA', indep: false, entreprise: true, custom: true },
            { feat: 'e-invoicing 2026 ready', indep: false, entreprise: true, custom: true },
          ]
        },
        {
          label: 'Conformité & réglementation',
          rows: [
            { feat: 'CERFA fluides auto-générés', indep: true, entreprise: true, custom: true },
            { feat: 'Registre fluides automatique', indep: true, entreprise: true, custom: true },
            { feat: 'Traçabilité bouteilles', indep: true, entreprise: true, custom: true },
            { feat: 'Alertes étalonnage détecteurs', indep: true, entreprise: true, custom: true },
          ]
        },
        {
          label: 'Clients & croissance',
          rows: [
            { feat: 'Gestion clients & contrats d\'entretien', indep: true, entreprise: true, custom: true },
            { feat: 'Portail client (documents, CERFA, RDV)', indep: false, entreprise: true, custom: true },
            { feat: 'SMS rappel RDV automatique', indep: false, entreprise: true, custom: true },
            { feat: 'Email post-intervention automatique', indep: false, entreprise: true, custom: true },
            { feat: 'Collecte d\'avis Google automatique', indep: false, entreprise: true, custom: true },
          ]
        },
        {
          label: 'Pilotage',
          rows: [
            { feat: 'Statistiques d\'activité', indep: 'Basique', entreprise: true, custom: true },
            { feat: 'Rentabilité par chantier & technicien', indep: false, entreprise: true, custom: true },
            { feat: 'Taux de transformation devis', indep: false, entreprise: true, custom: true },
            { feat: 'Paramétrage métier (appareils, travaux…)', indep: false, entreprise: true, custom: true },
          ]
        },
        {
          label: 'Support',
          rows: [
            { feat: 'Support chat & email', indep: true, entreprise: true, custom: true },
            { feat: 'Onboarding en visio', indep: true, entreprise: true, custom: true },
            { feat: 'Suivi à 30 jours', indep: true, entreprise: true, custom: true },
          ]
        },
      ],
      faqs: [
        { q: 'Puis-je changer d\'offre en cours d\'abonnement ?', a: 'Oui, à tout moment. Si vous passez d\'Indépendant à Entreprise, la facturation est ajustée au prorata du mois en cours. Vous accédez immédiatement aux nouvelles fonctionnalités.', open: false },
        { q: 'Qu\'est-ce qui compte comme "technicien" dans l\'offre Entreprise ?', a: 'Tout utilisateur ayant accès à l\'application mobile et au planning. Les comptes "bureau" (secrétaire, gérant) qui ne font pas d\'interventions ne comptent pas comme techniciens.', open: false },
        { q: 'La facturation est vraiment incluse sans supplément dans l\'Entreprise ?', a: 'Oui, totalement. Devis, factures, acomptes, suivi des paiements, relances, certification anti-fraude TVA — tout est inclus dans l\'abonnement Entreprise, aucun module supplémentaire à acheter.', open: false },
        { q: 'Comment fonctionne l\'essai gratuit ?', a: '14 jours d\'accès complet à l\'offre Entreprise, sans carte bancaire. À l\'issue, vous choisissez votre offre ou vous arrêtez — aucune facturation automatique.', open: false },
        { q: 'Je suis artisan seul, est-ce que l\'offre Indépendant suffit ?', a: 'Si vous cherchez principalement à être organisé, conforme (CERFA, fluides) et à gérer vos chantiers efficacement — oui. Si vous voulez aussi facturer depuis Termoflow, envoyer des devis professionnels ou avoir un portail client, l\'Entreprise est indispensable.', open: false },
      ]
    }
  }
}
</script>

<style scoped>
.gradient-text { background: linear-gradient(to right, #f97316, #ef4444); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }

/* HERO */
.hero-tarifs { padding: 10rem 1rem 4rem; background: radial-gradient(ellipse at top right,#fff7ed,transparent 45%), radial-gradient(ellipse at bottom left,#fef2f2,transparent 45%); text-align: center; }
.hero-badge { display:inline-block; padding:.5rem 1.25rem; background:white; border:1px solid #e5e7eb; border-radius:9999px; font-size:.75rem; font-weight:800; color:#f97316; text-transform:uppercase; letter-spacing:.08em; margin-bottom:1.75rem; }
.hero-title { font-size:clamp(2.5rem,5vw,3.75rem); font-weight:900; color:#111827; line-height:1.15; margin-bottom:1rem; }
.hero-sub { font-size:1.1rem; color:#6b7280; max-width:600px; margin:0 auto 2.5rem; line-height:1.7; }

/* Toggle annuel/mensuel */
.hero-toggle { display:inline-flex; align-items:center; gap:.85rem; background:white; border:1px solid #e5e7eb; border-radius:9999px; padding:.65rem 1.5rem; cursor:pointer; }
.hero-toggle span { font-size:.88rem; font-weight:700; color:#94a3b8; cursor:pointer; transition:color .2s; user-select:none; }
.hero-toggle .toggle-active { color:#111827; font-weight:800; }
.toggle-switch { width:2.5rem; height:1.35rem; border-radius:9999px; background:#e5e7eb; position:relative; transition:background .2s; flex-shrink:0; }
.toggle-switch.toggled { background:#f97316; }
.toggle-thumb { position:absolute; top:2px; left:2px; width:1rem; height:1rem; background:white; border-radius:50%; transition:left .2s; box-shadow:0 1px 3px rgba(0,0,0,.2); }
.toggle-switch.toggled .toggle-thumb { left:calc(100% - 18px); }
.toggle-save { background:#dcfce7; color:#166534; font-size:.65rem; font-weight:800; padding:.2rem .5rem; border-radius:9999px; margin-left:.3rem; vertical-align:middle; }

/* CARDS */
.cards-section { padding:3rem 0 4rem; }
.cards-grid { display:grid; grid-template-columns:1fr 1.15fr 1fr; gap:1.5rem; align-items:start; }
@media(max-width:900px) { .cards-grid { grid-template-columns:1fr; } }

.tier-card { background:white; border:1px solid #e5e7eb; border-radius:1.75rem; overflow:hidden; }
.tier-card.tier-featured { border:2px solid #f97316; box-shadow:0 20px 60px -12px rgba(249,115,22,.2); position:relative; }
.tier-card.tier-custom { border-style:dashed; border-color:#d1d5db; }

.featured-ribbon { position:absolute; top:1.25rem; right:-3.5rem; background:linear-gradient(to right,#f97316,#ef4444); color:white; transform:rotate(45deg); padding:.4rem 4rem; font-size:.65rem; font-weight:900; text-transform:uppercase; letter-spacing:.08em; }

.tier-head { padding:2rem 2rem 1.5rem; border-bottom:1px solid #f1f5f9; text-align:center; }
.featured-head { background:linear-gradient(135deg,#fff7ed,#fff); }
.tier-icon { width:3rem; height:3rem; border-radius:1rem; display:flex; align-items:center; justify-content:center; font-size:1.25rem; margin:0 auto 1rem; }
.indep-icon { background:#f1f5f9; color:#64748b; }
.entreprise-icon { background:linear-gradient(135deg,#f97316,#ef4444); color:white; }
.custom-icon { background:#0f172a; color:#94a3b8; }

.tier-name { font-size:1.1rem; font-weight:900; text-transform:uppercase; letter-spacing:.1em; color:#374151; margin-bottom:.35rem; }
.featured-name { color:#f97316; }
.tier-tagline { font-size:.82rem; color:#94a3b8; font-weight:600; line-height:1.4; margin-bottom:1.1rem; }
.featured-tagline { color:#78350f; }

.tier-price { display:flex; align-items:flex-end; justify-content:center; gap:.4rem; margin-bottom:.3rem; }
.tp-val { font-size:2.25rem; font-weight:900; color:#111827; line-height:1; }
.custom-val { font-size:1.5rem; color:#64748b; }
.tp-unit { font-size:.82rem; font-weight:600; color:#94a3b8; padding-bottom:.25rem; }
.tier-old { font-size:.72rem; color:#94a3b8; font-weight:600; margin-bottom:1.5rem; }
.featured-old { color:#f97316; font-weight:700; }

.btn-indep { width:100%; padding:.9rem; border-radius:.85rem; border:2px solid #e5e7eb; background:white; font-weight:800; color:#374151; font-size:.9rem; cursor:pointer; transition:border-color .2s,background .2s; }
.btn-indep:hover { border-color:#f97316; color:#f97316; }
.btn-entreprise { width:100%; padding:.9rem; border-radius:.85rem; border:none; background:linear-gradient(to right,#f97316,#ef4444); font-weight:800; color:white; font-size:.9rem; cursor:pointer; box-shadow:0 4px 14px rgba(249,115,22,.35); }
.btn-custom { width:100%; padding:.9rem; border-radius:.85rem; border:1px solid #1e293b; background:#0f172a; font-weight:800; color:white; font-size:.9rem; cursor:pointer; }

.trial-note { font-size:.7rem; font-weight:700; color:#94a3b8; margin-top:.6rem; }
.featured-trial { color:#c2410c; }

.tier-body { padding:1.5rem 2rem 2rem; }
.featured-body { background:#fffbf7; }

.tier-limit-banner { background:#f1f5f9; border-radius:.65rem; padding:.65rem 1rem; font-size:.78rem; font-weight:800; color:#475569; display:flex; align-items:center; gap:.5rem; margin-bottom:1.25rem; }
.tier-limit-banner i { color:#94a3b8; }

.featured-value-banner { background:#fff7ed; border:1px solid #fed7aa; border-radius:.85rem; padding:.85rem 1.1rem; font-size:.8rem; font-weight:700; color:#92400e; display:flex; align-items:flex-start; gap:.65rem; margin-bottom:1.5rem; line-height:1.5; }
.featured-value-banner i { color:#f97316; flex-shrink:0; margin-top:.1rem; }

.tier-section-title { font-size:.65rem; font-weight:800; text-transform:uppercase; letter-spacing:.08em; color:#94a3b8; margin-bottom:.85rem; }
.mt-6 { margin-top:1.5rem; }

.feat-list { display:flex; flex-direction:column; gap:.75rem; }
.fl-item { display:flex; align-items:flex-start; gap:.6rem; font-size:.82rem; }
.fl-item strong { display:block; font-weight:800; color:#1e293b; line-height:1.3; }
.fl-note { display:block; font-size:.72rem; color:#94a3b8; font-weight:600; line-height:1.4; }
.fl-check { color:#22c55e; font-size:.7rem; margin-top:.2rem; flex-shrink:0; }
.fl-x { color:#ef4444; font-size:.7rem; margin-top:.2rem; flex-shrink:0; }
.fl-plus { color:#f97316; font-size:.65rem; margin-top:.2rem; flex-shrink:0; }
.fl-missing { opacity:.5; }
.fl-missing span { font-size:.82rem; color:#374151; }
.fl-extra { }

/* COMPARE TABLE */
.compare-section { padding:4rem 0 5rem; background:#f9fafb; }
.compare-table { background:white; border-radius:1.5rem; border:1px solid #e5e7eb; overflow:hidden; }

.ct-head { display:grid; grid-template-columns:2fr 1fr 1.15fr 1fr; background:#f8fafc; border-bottom:2px solid #e5e7eb; }
.ct-feat-col,.ct-plan-col { padding:1.25rem 1rem; }
.ct-feat-col { }
.ct-plan-col { text-align:center; border-left:1px solid #f1f5f9; }
.ct-featured-col { background:linear-gradient(180deg,#fff7ed,#fff); border-left:2px solid #fed7aa; border-right:2px solid #fed7aa; }
.ct-plan-badge { font-size:.6rem; font-weight:800; background:#f97316; color:white; padding:.2rem .65rem; border-radius:9999px; text-transform:uppercase; letter-spacing:.05em; display:inline-block; margin-bottom:.3rem; }
.ct-plan-name { font-size:.82rem; font-weight:800; color:#374151; }
.featured-plan-name { color:#f97316; }
.ct-plan-price { font-size:1.1rem; font-weight:900; color:#111827; margin-top:.2rem; }
.ct-plan-price span { font-size:.72rem; font-weight:600; color:#94a3b8; }
.featured-plan-price { color:#f97316; }

.ct-group-label { padding:.65rem 1.25rem; background:#f8fafc; border-top:1px solid #f1f5f9; border-bottom:1px solid #f1f5f9; font-size:.65rem; font-weight:800; text-transform:uppercase; letter-spacing:.08em; color:#94a3b8; }
.ct-row { display:grid; grid-template-columns:2fr 1fr 1.15fr 1fr; border-bottom:1px solid #f8fafc; }
.ct-row:last-child { border-bottom:none; }
.ct-feat { padding:.75rem 1.25rem; font-size:.82rem; font-weight:600; color:#374151; display:flex; align-items:center; gap:.4rem; }
.ct-tip { width:1.1rem; height:1.1rem; border-radius:50%; background:#f1f5f9; color:#94a3b8; font-size:.62rem; font-weight:800; display:inline-flex; align-items:center; justify-content:center; cursor:help; flex-shrink:0; }
.ct-cell { padding:.75rem 1rem; text-align:center; display:flex; align-items:center; justify-content:center; border-left:1px solid #f8fafc; }
.ct-featured-cell { background:rgba(255,247,237,.3); border-left:2px solid #fed7aa; border-right:2px solid #fed7aa; }
.ct-yes { color:#22c55e; font-size:.85rem; }
.ct-no { color:#d1d5db; font-size:.85rem; }
.ct-partial { font-size:.72rem; font-weight:700; color:#f97316; }

.ct-foot { display:grid; grid-template-columns:2fr 1fr 1.15fr 1fr; padding:.75rem 0; background:#f8fafc; border-top:1px solid #e5e7eb; }
.ct-feat-col { }
.ct-cta-cell { padding:.5rem 1rem; text-align:center; }
.cta-table-btn { width:100%; padding:.65rem; border-radius:.65rem; font-size:.78rem; font-weight:800; cursor:pointer; }
.cta-outline { border:1.5px solid #e5e7eb; background:white; color:#374151; }
.cta-orange { border:none; background:linear-gradient(to right,#f97316,#ef4444); color:white; }

/* ROI */
.roi-section { padding:5rem 0; background:white; }
.roi-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:1.5rem; margin-bottom:2rem; }
@media(max-width:700px){ .roi-grid { grid-template-columns:1fr 1fr; } }
.roi-item { background:#f9fafb; border:1px solid #f1f5f9; border-radius:1.25rem; padding:1.75rem; text-align:center; }
.roi-val { font-size:2.25rem; font-weight:900; color:#f97316; margin-bottom:.4rem; }
.roi-lab { font-size:.8rem; font-weight:700; color:#64748b; line-height:1.4; }
.roi-cta-link { display:inline-flex; align-items:center; gap:.5rem; font-size:.9rem; font-weight:800; color:#f97316; text-decoration:none; border-bottom:2px solid #fed7aa; padding-bottom:2px; }

/* FAQ */
.faq-section { padding:4rem 0 5rem; background:#f9fafb; }
.faq-list { border-radius:1.25rem; overflow:hidden; border:1px solid #e5e7eb; }
.faq-item { border-bottom:1px solid #f1f5f9; cursor:pointer; background:white; }
.faq-item:last-child { border-bottom:none; }
.faq-q { display:flex; align-items:center; justify-content:space-between; padding:1.25rem 1.5rem; font-size:.95rem; font-weight:800; color:#1e293b; gap:1rem; }
.faq-q i { color:#94a3b8; font-size:.8rem; flex-shrink:0; }
.faq-a { padding:.25rem 1.5rem 1.25rem; font-size:.88rem; color:#6b7280; line-height:1.7; }

/* CTA FINAL */
.cta-final { background:#0f172a; padding:6rem 0; }
.btn-cta-white { background:white; color:#1e293b; padding:1.1rem 2.5rem; border-radius:9999px; font-weight:800; border:none; font-size:.95rem; cursor:pointer; }
.btn-cta-orange { background:linear-gradient(to right,#f97316,#ef4444); color:white; padding:1.1rem 2.5rem; border-radius:9999px; font-weight:800; border:none; font-size:.95rem; cursor:pointer; }

@media(max-width:1024px){ .hero-tarifs { padding-top:8rem; } }
</style>